import styled from 'styled-components'
import Select from '../Select'

export const StyledSelect = styled(Select)`
  margin-bottom: 0; 
`

export const SearchDropdownIconWrapper = styled.div`
  position: relative;
`

export const SearchDropdownIcon = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: ${(p) => {
    return p.iconTopPosition
  }};
  height: 24px;
  width: 24px;
  margin-left: ${(p) => {
    return p.buttonIsPresent ? '16px' : '8px'
  }};
  z-index: 1;
`

export const SearchDropDownDivider = styled.div`
  position: absolute; 
  top: ${(p) => {
    return p.iconTopPosition
  }};
  background: rgba(32, 32, 32, 0.1);
  height: 24px;
  width: 1px;
  margin-left: 50px;
  z-index: 1;
`

export const ClearSearchDropdownIcon = styled(SearchDropdownIcon)`
  right: 156px;
  cursor: pointer;
  background: rgba(32, 32, 32, 0.05);
  border-radius: 50%
`

export const SearchDropdownButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -28px;
  right: 0px;
  z-index: 1;
`

export const SearchDropdownContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const SearchSelectContainer = styled.div`
  width: ${(p) => {
    return p.buttonIsPresent ? 'calc(100% - 146px)' : '100%'
  }};
  margin-right: 4px;
`
